
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/UserDocs/AdvancedTopics/ClassificationSystem",
      function () {
        return require("private-next-pages/docs/UserDocs/AdvancedTopics/ClassificationSystem.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/UserDocs/AdvancedTopics/ClassificationSystem"])
      });
    }
  